import Angular from "angular";
import Controller from "./login.controller";
import Template from "./login.html";
import Settings from "../../providers/settings.provider";
import AuthService from "../../services/auth.service";

export const LoginView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.login', [Settings.name, AuthService.name]);



// WEBPACK FOOTER //
// ./src/modules/main/views/login/login.js